import React from 'react';
import { View, Image } from 'react-native';
import { styles } from '../authScreen/authScreen.styles';
import CentralModal from 'src/components/CenteredModal/CenteredModal';
import cardTruck from 'src/assets/cardTruck-4x.png';
import Typography from 'src/components/Text/Text';
interface SecondUserScreenProps {
  dotNumber: string;
}

const SecondUserScreen: React.FC<SecondUserScreenProps> = ({ dotNumber }) => {
  return (
    <CentralModal>
      <View style={styles.container}>
        <View style={styles.logoContainer}>
          <Image source={cardTruck} style={styles.logoImage} />
        </View>
        <Typography style={styles.topText} variant="h4">
          Account Already in Use
        </Typography>
        <Typography variant="body1" style={styles.bottomText}>
          {`Your DOT number matches that of an existing account with us. We've sent an email to the current account owner to request access on your behalf.`}
        </Typography>
        <View style={styles.emailContainer}>
          <Typography variant="h4">DOT Number: </Typography>
          <Typography variant="title2">{dotNumber}</Typography>
        </View>
        <Typography variant="body1" style={styles.bottomText}>
          If you believe you should be the owner of this account, please contact us at
          <Typography style={styles.link}> support@truckerpathinsurance.com</Typography> and we can
          get it sorted for you
        </Typography>
      </View>
    </CentralModal>
  );
};

export default SecondUserScreen;
